const showReferralToast = function ({ store }) {
    store.commit('content/INCREASE_PAGE_COUNT');
};

export default showReferralToast;
